import React from "react";
import Lodable from "react-loadable";
import { AppLoading } from "../loaders/loaders";
import appConstants from "@appConstants";
import {
  CLOSED_TRAILERS_TITLE_ICON,
  PICKUPS_TITLE_ICON,
  TRAILER_MOVES_TITLE_ICON,
} from "./layoutTitleIcons";
import DriverMapHeader from "../components/modules/Dispatch/RouteExecution/DriverMap/components/MapHeader";
import { RouteMapHeader } from "../components/modules/IBPlanning/RoutesView/RouteMap/components";
import CustomerMapHeader from "../components/modules/CustomerManagement/CustomerMapHeader";
import PickupGridHeader from "../components/modules/Dispatch/RouteExecution/Pickups/components/PickupGridHeader/PickupGridHeader"
const ShipmentsGrid = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/ShipmentsGrid"),
  loading: AppLoading,
});

const ShipmentsMap = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/ShipmentsMap"),
  loading: AppLoading,
});

const RoutesGrid = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/RoutesView/RoutesGrid"),
  loading: AppLoading,
});
const StopsGrid = Lodable({
  loader: () => import("../components/modules/IBPlanning/RoutesView/StopsGrid"),
  loading: AppLoading,
});
const RoutesMap = Lodable({
  loader: () => import("../components/modules/IBPlanning/RoutesView/RouteMap"),
  loading: AppLoading,
});

const CustomerGrid = Lodable({
  loader: () => import("../components/modules/CustomerManagement/CustomerGrid"),
  loading: AppLoading,
});
const ShipperGrid = Lodable({
  loader: () => import("../components/modules/CustomerManagement/ShipperGrid"),
  loading: AppLoading,
})
const CustomerMap = Lodable({
  loader: () => import("../components/modules/CustomerManagement/CustomerMap"),
  loading: AppLoading,
});

const CustomerQuickFilter = Lodable({
  loader: () => import("../components/modules/CustomerManagement/QuickFilter"),
  loading: AppLoading,
});

const KPIPanel = Lodable({
  loader: () => import("../components/modules/IBPlanning/KPI/KPIPanel"),
  loading: AppLoading,
});
const SettingsPage = Lodable({
  loader: () => import("../components/modules/Settings/index"),
  loading: AppLoading,
});

const QuickFilter = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/QuickFilter"),
  loading: AppLoading,
});

const ReportsPage = Lodable({
  loader: () => import("../components/modules/Reports/index"),
  loading: AppLoading,
});

const DockComplianceKPIReport = Lodable({
  loader: () => import("../components/modules/Reports/DockCompliance/KPIPanel"),
  loading: AppLoading,
});

const DriverPerformance = Lodable({
  loader: () =>
    import("../components/modules/Reports/DriverPerformance/RealtimeReport"),
  loading: AppLoading,
});

const NextStopComplianceReportsKPI = Lodable({
  loader: () =>
    import("../components/modules/Reports/NextStopCompliance/KPIPanel"),
  loading: AppLoading,
});

const DispatchKPI = Lodable({
  loader: () => import("../components/modules/Dispatch/KPI/KPIPanel"),
  loading: AppLoading,
});

const DispatchedDriverGrid = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/Drivers/Grid"),
  loading: AppLoading,
});

const AssetManagement = Lodable({
  loader: () => import("../components/modules/Dispatch/AssetManagement"),
  loading: AppLoading,
});
const DispatchDriversMap = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/DriverMap"),
  loading: AppLoading,
});
const DispatchPickupsGrid = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/Pickups/GroupPickup/index"),
  loading: AppLoading,
});
const DispatchQuickFilter = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/AssetManagement/QuickFilter/index"),
  loading: AppLoading,
});

const ShipmentSelection = Lodable({
  loader: () =>
    import("../components/modules/ShipmentSelection"),
  loading: AppLoading,
});

const ShipmentForecast = Lodable({
  loader: () =>
    import("../components/modules/ShipmentForecast"),
  loading: AppLoading,
})

const ShipmentForecastQuickFilter = Lodable({
  loader: () =>
    import("../components/modules/ShipmentForecast/QuickFilter"),
  loading: AppLoading,
})

const ClosedTrailersGrid = Lodable({
  loader: () => import('../components/modules/Dispatch/RouteExecution/ClosedTrailers/index'),
  loading: AppLoading
});
const ClosedTrailersGridHeader = Lodable({
  loader: () => import('../components/modules/Dispatch/RouteExecution/ClosedTrailers/components/CloseTrailerGridHeader'),
  loading: AppLoading
});
const TrailerMovesGrid = Lodable({
  loader: () => import('../components/modules/Dispatch/RouteExecution/TrailerMoves/index'),
  loading: AppLoading
});
const TrailerMovesGridHeader = Lodable({
  loader: () => import('../components/modules/Dispatch/RouteExecution/TrailerMoves/components/TrailerMovesGridHeader'),
  loading: AppLoading
});

export function getLayoutConfiguration(locationURL, configJSON) {
  const { NAV_URLS } = appConstants;
  switch (locationURL.toLowerCase()) {
    case NAV_URLS.IBPLANNING_ROUTES:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "RoutesGrid",
                      id: appConstants.gridNames.RoutesGrid,
                      title: "Routes",
                      gridHeader: {
                        searchBox: true,
                        showHideColumn: true,
                        showTSP: true,
                        showMergeRoutes: true,
                        print: true,
                        showEdit: true,
                        showExportCSV: true,
                        showTutorial : true
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "RoutesMap",
                  customProp: "A",
                  title: "Routes Map",
                  id: appConstants.layout.RoutesMap,
                  isClosable: false,
                  gridHeader: {
                    componentName: "RouteMapHeader",
                  },
                },
              ],

              height: 60,
            },
            {
              type: "stack",
              header: {
                popout: false,
              },
              content: [
                {
                  type: "react-component",
                  component: "StopsGrid",
                  id: appConstants.gridNames.StopsGrid,
                  customProp: "B",
                  title: "Stops",
                  gridHeader: {
                    searchBox: true,
                    showHideColumn: true,
                    showEdit: true,
                    showExportCSV: true,
                    showMergeStops: true,
                    showTutorial : true
                  },
                },
                {
                  type: "react-component",
                  component: "ShipmentsGrid",
                  location: locationURL,
                  title: "Shipments",
                  id: appConstants.gridNames.ShipmentsGrid,
                  gridHeader: {
                    searchBox: true,
                    showHideColumn: true,
                    showExportCSV: true,
                    showEdit: true,
                    geocode: true,
                    showTutorial : true,
                    showShipmentComment: true
                  },
                },
              ],
              height: 30,
            },
            {
              type: "stack",
              content: [
                {
                  type: "react-component",
                  component: "KPIPanel",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                  minHeight: 50, //in pixel
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.IBPLANNING_SHIPMENTS:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "QuickFilter",
                      title: "Quick Filter",
                      id: appConstants.layout.QuickFilter,
                      header: {
                        popout: false,
                        show: false,
                      },
                      minWidth: 220, //in pixel
                    },
                  ],
                  width: 12.5,
                },
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "ShipmentsGrid",
                      location: locationURL,
                      title: "Shipments",
                      id: appConstants.gridNames.ShipmentsGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: true,
                        showExportCSV: true,
                        geocode: true,
                        showTutorial: true,
                        showShipmentComment: true
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "ShipmentsMap",
                  //  customProp: 'E',
                  title: "Shipments Map",
                  id: appConstants.layout.ShipmentsMap,
                  isClosable: false,
                  gridHeader: {
                    mapTools: {
                      mapId: appConstants.mapIds.SHIPMENTS_MAP,
                      measureTool: true,
                      lasso: true,
                      delete: true,
                    },
                    showPopout: true,
                    showTutorial : true
                  },
                },
              ],
            },
            {
              type: "column",
              content: [
                {
                  type: "stack",
                  hideHeader: true,
                  content: [
                    {
                      type: "react-component",
                      component: "KPIPanel",
                      title: "KPI",
                      id: appConstants.layout.KPIPanel,
                      header: {
                        popout: false,
                        show: false,
                      },
                    },
                  ],
                  minHeight: 50, //in pixel
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.IBPLANNING_CUSTOMERS:
      return [
        {
          type: 'column',
          content: [
            {
              type: 'row',
              content: [
                {
                  type: 'stack',
                  content: [
                    {
                      type: 'react-component',
                      component: 'CustomerQuickFilter',
                      title: 'Quick Filter',
                      id: appConstants.layout.CustomerQuickFilter,
                      header: {
                        popout: false,
                        show: false
                      },
                      minWidth: 220 //in pixel
                    }
                  ],
                  width: 12.5
                },
                {
                  type: 'stack',
                  content: [
                    {
                      type: 'react-component',
                      component: 'CustomerGrid',
                      location: locationURL,
                      title: 'Customers',
                      id: appConstants.gridNames.CustomerGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        showHideColumn: true,
                        showExportCSV: true,
                        geocode: true,
                        showEdit: true,
                        showTutorial: true
                      }
                    },
                    ...(configJSON?.showShippersInCustomerManagement
                      ? [
                          {
                            type: 'react-component',
                            component: 'ShipperGrid',
                            location: locationURL,
                            title: 'Shippers',
                            id: appConstants.gridNames.ShipperGrid,
                            gridHeader: {
                              exportIcon: true,
                              searchBox: true,
                              showHideColumn: true,
                              showExportCSV: true,
                              geocode: true,
                              showRefresh: configJSON?.enableShipperSyncFromUI,
                              refreshConfig: {
                                title: "Sync all shipper details",
                                inProgressTitle: "Syncing shipper details...",
                              }
                            }
                          }
                        ]
                      : [])
                  ]
                },
                {
                  type: 'react-component',
                  component: 'CustomerMap',
                  title: 'Customers Map',
                  id: appConstants.layout.CustomerMap,
                  isClosable: false,
                  gridHeader: {
                    componentName: 'CustomerMapHeader'
                  }
                }
              ]
            }
          ]
        }
      ];
      case NAV_URLS.SETTINGS:
        return [
          {
            type: "row",
            content: [
              {
                type: "react-component",
                component: "SettingsPage",
                title: "Settings",
                id: appConstants.layout.SettingsPage,
                header: {
                  popout: false,
                  show: false,
                  maximise: false,
                },
              },
            ],
          },
        ];
      case NAV_URLS.SHIPMENT_SELECTION:
        return [
          {
            type: "row",
            content: [
              {
                type: "react-component",
                component: "ShipmentSelection",
                title: "Shipment Selection",
                id: "ShipmentSelection",
                header: {
                  popout: false,
                  show: false,
                  maximise: false,
                },
              },
            ],
          },
        ];
      case NAV_URLS.SHIPMENT_FORECAST:
          return [
            {
              type: "row",
              content: [
                {
                    type: "stack",
                    content: [
                      {
                        type: "react-component",
                        component: "ShipmentForecastQuickFilter",
                        title: "Quick Filter",
                        id: appConstants.layout.QuickFilter,
                        header: {
                          popout: false,
                          show: false,
                        },
                        minWidth: 220, //in pixel
                      },
                    ],
                    width: 20
                  },
                {
                  type: "react-component",
                  component: "ShipmentForecast",
                  title: "Shipment Forecast",
                  id: "ShipmentForecast",
                  header: {
                    popout: false,
                    show: false,
                    maximise: false,
                  },
                },
              ],
            },
          ];
      case NAV_URLS.REPORT_IBPSUMMARY:
      case NAV_URLS.REPORT_PUBLISH_STATUS:
      case NAV_URLS.REPORT_PRO_HISTORY:
      case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
      case NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY:
      case NAV_URLS.REPORT_KPI_SUMMARY:
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
      case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
      case NAV_URLS.REPORT_MERGED_CUSTOMERS:
      case NAV_URLS.REPORT_RECORDS_lOOKUP:
      case NAV_URLS.REPORT_USAGE_REPORT:
      case NAV_URLS.REPORT_ROUTE_AUDIT:
        return [
          {
            type: "row",
            content: [
              {
                type: "react-component",
                component: "ReportsPage",
                title: "Reports",
                location: locationURL,
                id: appConstants.layout.Reports,
                header: {
                  popout: false,
                  show: false,
                  maximise: false,
                },
              },
            ],
          },
        ];
      case NAV_URLS.REPORT_DOCK_COMPLIANCE:
        return [
          {
            type: "column",
            content: [
              {
                type: "row",
                content: [
                  {
                    type: "stack",
                    content: [
                      {
                        type: "react-component",
                        component: "ReportsPage",
                        title: "Reports",
                        location: locationURL,
                        id: appConstants.layout.Reports,
                        header: {
                          popout: false,
                          show: false,
                          maximise: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: "stack",
                hideHeader: true,
                content: [
                  {
                    type: "react-component",
                    component: "KPIPanel",
                    title: "KPI",
                    id: appConstants.layout.KPIPanel,
                    header: {
                      popout: false,
                      show: false,
                    },
                  },
                ],
                height: 7,
                minHeight: 50, //in pixel
              },
            ],
          },
        ];
      case NAV_URLS.NEXT_STOP_COMPLIANCE:
        return [
          {
            type: "column",
            content: [
              {
                type: "row",
                content: [
                  {
                    type: "stack",
                    content: [
                      {
                        type: "react-component",
                        component: "ReportsPage",
                        title: "Reports",
                        location: locationURL,
                        id: appConstants.layout.Reports,
                        header: {
                          popout: false,
                          show: false,
                          maximise: false,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: "stack",
                hideHeader: true,
                content: [
                  {
                    type: "react-component",
                    component: "NextStopComplianceReportsKPI",
                    title: "KPI",
                    id: appConstants.layout.KPIPanel,
                    header: {
                      popout: false,
                      show: false,
                    },
                  },
                ],
                height: 7,
                minHeight: 50, //in pixel
              },
            ],
          },
        ];
    case NAV_URLS.DISPATCH_ROUTEEXECUTION:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "column",
                  content: [
                    {
                      type: 'stack',
                      content: [
                        {
                          type: "react-component",
                          component: "DispatchPickupsGrid",
                          location: locationURL,
                          tooltip: 'Pickups',
                          title: PICKUPS_TITLE_ICON,
                          id: appConstants.gridNames.PickupsGrid,
                          gridHeader: {
                            componentName: "PickupGridHeader",
                           },
                          },
                          ...(configJSON.enablePreDispatch
                            ? [
                                {
                                  type: 'react-component',
                                  component: 'ClosedTrailersGrid',
                                  location: locationURL,
                                  tooltip: 'Closed Trailers',
                                  title: CLOSED_TRAILERS_TITLE_ICON,
                                  id: appConstants.gridNames.ClosedTrailersGrid,
                                  gridHeader: {
                                    componentName: 'ClosedTrailersGridHeader',
                                    printPhysicalDr: Boolean(configJSON?.enablePhysicalDrPrintPreview),
                                  }
                                }
                              ]
                          : []),
                          ...(configJSON.enableTrailerSwapBoard
                            ? [
                                {
                                  type: 'react-component',
                                  component: 'TrailerMovesGrid',
                                  location: locationURL,
                                  tooltip: 'Trailer Moves',
                                  title: TRAILER_MOVES_TITLE_ICON,
                                  id: appConstants.gridNames.TrailerMovesGrid,
                                  gridHeader: {
                                    componentName: 'TrailerMovesGridHeader',
                                  },
                                },
                              ]
                            : []),
                        ]
                      },
                    {
                      type: "react-component",
                      component: "DispatchedDriverGrid",
                      location: locationURL,
                      title: "Drivers",
                      id: appConstants.gridNames.DispatchedDriverGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: false,
                        showExportCSV: true,
                        geocode: false,
                        equipmentDefects: true,
                        groupMsg: true,
                        cancelDispatch: true,
                        createDispatch: true,
                        endTrip: true,
                        showTutorial: true,
                        printPhysicalDr: Boolean(configJSON?.enablePhysicalDrPrintPreview),
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "DispatchDriversMap",
                  //  customProp: 'E',
                  title: "Dispatch Map",
                  id: appConstants.layout.DispatchDriversMap,
                  isClosable: false,
                  gridHeader: {
                    componentName: "DriverMapHeader",
                  },
                },
              ],
            },
            {
              type: "stack",
              content: [
                {
                  type: "react-component",
                  component: "DispatchKPI",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.DISPATCH_ASSET_MANAGEMENT:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "DispatchQuickFilter",
                      title: "Quick Filter",
                      id: appConstants.layout.DispatchQuickFilter,
                      header: {
                        popout: false,
                        show: false,
                      },
                      minWidth: 220, //in pixel
                    },
                  ],
                  width: 12.5,
                },
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "AssetManagement",
                      location: locationURL,
                      title: "AssetManagement",
                      id: appConstants.gridNames.AssetManagement,
                      header: {
                        popout: false,
                        show: false,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "stack",
              hideHeader: true,
              content: [
                {
                  type: "react-component",
                  component: "DispatchKPI",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "DriverPerformanceReport",
                      id: "dpReport",
                      title: "dpReport",
                      header: {
                        show: false,
                        maximise: false,
                      },
                    },
                  ],
                },
              ],

              height: 60,
            },
          ],
        },
      ];
  }
}
// In case we are using store then here we can pass it to the component
function wrapComponent(Component, theme) {
  class Wrapped extends React.Component {
    render() {
      return (
        //    <MuiThemeProvider theme={theme}>
        <Component {...this.props} />
        //    </MuiThemeProvider>
      );
    }
  }
  return Wrapped;
}
export function registerComponents(locationURL, layout, configJSON) {
  const { NAV_URLS } = appConstants;
  switch (locationURL.toLowerCase()) {
    case NAV_URLS.IBPLANNING_ROUTES:
      layout.registerComponent("RoutesGrid", RoutesGrid);
      layout.registerComponent("ShipmentsGrid", ShipmentsGrid);
      layout.registerComponent("StopsGrid", StopsGrid);
      layout.registerComponent("RoutesMap", RoutesMap);
      layout.registerComponent("RouteMapHeader", RouteMapHeader);
      layout.registerComponent("KPIPanel", KPIPanel);
      return layout;
    case NAV_URLS.IBPLANNING_SHIPMENTS:
      layout.registerComponent("ShipmentsMap", ShipmentsMap);
      layout.registerComponent("ShipmentsGrid", ShipmentsGrid);
      layout.registerComponent("QuickFilter", QuickFilter);
      layout.registerComponent("KPIPanel", KPIPanel);
      return layout;
    case NAV_URLS.IBPLANNING_CUSTOMERS:
      layout.registerComponent("CustomerGrid", CustomerGrid);
      configJSON?.showShippersInCustomerManagement &&
        layout.registerComponent("ShipperGrid", ShipperGrid);
      layout.registerComponent("CustomerMapHeader", CustomerMapHeader);
      layout.registerComponent("CustomerMap", CustomerMap);
      layout.registerComponent("CustomerQuickFilter", CustomerQuickFilter);
      return layout;
    case NAV_URLS.DISPATCH_ROUTEEXECUTION:
      layout.registerComponent("DispatchKPI", DispatchKPI);
      layout.registerComponent("DispatchedDriverGrid", DispatchedDriverGrid);
      layout.registerComponent("DispatchPickupsGrid", DispatchPickupsGrid);
      layout.registerComponent("DispatchDriversMap", DispatchDriversMap);
      layout.registerComponent("DriverMapHeader", DriverMapHeader);
      layout.registerComponent("PickupGridHeader", PickupGridHeader);
      if (configJSON.enableTrailerSwapBoard) {
        layout.registerComponent('TrailerMovesGrid', TrailerMovesGrid);
        layout.registerComponent('TrailerMovesGridHeader', TrailerMovesGridHeader);
      }
      if (configJSON.enablePreDispatch) {
        layout.registerComponent('ClosedTrailersGrid', ClosedTrailersGrid);
        layout.registerComponent("ClosedTrailersGridHeader", ClosedTrailersGridHeader);
      }
      return layout;
      case NAV_URLS.DISPATCH_ASSET_MANAGEMENT:
        layout.registerComponent("DispatchKPI", DispatchKPI);
        layout.registerComponent("DispatchQuickFilter", DispatchQuickFilter);
        layout.registerComponent("AssetManagement", AssetManagement);
        return layout;
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
        layout.registerComponent("DriverPerformanceReport", DriverPerformance);
        return layout;
      case NAV_URLS.SETTINGS:
        layout.registerComponent("SettingsPage", SettingsPage);
        return layout;
      case NAV_URLS.SHIPMENT_SELECTION:
        layout.registerComponent("ShipmentSelection", ShipmentSelection);
        return layout;
      case NAV_URLS.SHIPMENT_FORECAST:
        layout.registerComponent("ShipmentForecast", ShipmentForecast);
        layout.registerComponent("ShipmentForecastQuickFilter", ShipmentForecastQuickFilter);
        return layout;
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
      case NAV_URLS.REPORT_IBPSUMMARY:
      case NAV_URLS.REPORT_DOCK_COMPLIANCE:
      case NAV_URLS.REPORT_KPI_SUMMARY:
      case NAV_URLS.REPORT_PRO_HISTORY:
      case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
      case NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY:
      case NAV_URLS.NEXT_STOP_COMPLIANCE:
      case NAV_URLS.REPORT_MERGED_CUSTOMERS:
      case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
      case NAV_URLS.REPORT_RECORDS_lOOKUP:
      case NAV_URLS.REPORT_USAGE_REPORT:
      case NAV_URLS.REPORT_ROUTE_AUDIT:
        layout.registerComponent("ReportsPage", ReportsPage);
        layout.registerComponent("KPIPanel", DockComplianceKPIReport);
        layout.registerComponent(
          "NextStopComplianceReportsKPI",
          NextStopComplianceReportsKPI
        );
        return layout;
    }
  }
